import { graphql } from '@gql/gql';

export const catalogRatiosSubGroupsGql = graphql(`
    query catalogRatioSubGroups($parentId: Long!) {
        catalogRatioSubGroups(parentId: $parentId) {
            name
            id
        }
    }
`);

export const addRatiosModalCodeFilterGql = graphql(`
    query addRatiosModalCodeFilter(
        $order: [CatalogRatioDataForListSortInput!]
        $skip: Int
        $take: Int
        $where: CatalogRatioDataForListFilterInput
    ) {
        catalogRatios(order: $order, skip: $skip, take: $take, where: $where) {
            items {
                code
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const addRatiosModalNameFilterGql = graphql(`
    query addRatiosModalNameFilter(
        $order: [CatalogRatioDataForListSortInput!]
        $skip: Int
        $take: Int
        $where: CatalogRatioDataForListFilterInput
    ) {
        catalogRatios(order: $order, skip: $skip, take: $take, where: $where) {
            items {
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
